import React, { useState } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
  useCreateFavouriteUserFolderMutation,
  useDestroyFavouriteUserFolderMutation,
} from 'components/hooks/favouriteUserFolderMutations';

import { useBreadBoard } from 'components/contexts/Toaster';

import FilledStarIcon from '-!svg-react-loader?name=FilledStarIcon!icons/filled-star.svg';
import StarIcon from '-!svg-react-loader?name=StarIcon!icons/star.svg';

export default function FavouriteFolderToggleButton({
  favouriteUserFolderId,
  folderId,
}) {
  const breadBoard = useBreadBoard();

  const [isHovered, setIsHovered] = useState(false);

  const createFavouriteUserFolderMutation =
    useCreateFavouriteUserFolderMutation();
  const destroyFavouriteUserFolderMutation =
    useDestroyFavouriteUserFolderMutation();

  const handleAddToFavouritesClick = () => {
    createFavouriteUserFolderMutation.mutate(
      { favouriteUserFolderParams: { folder_id: folderId, position: 1 } },
      { onError: breadBoard.addInedibleToast },
    );
  };

  const handleRemoveFromFavouritesClick = () => {
    destroyFavouriteUserFolderMutation.mutate(
      { id: favouriteUserFolderId },
      { onError: breadBoard.addInedibleToast },
    );
  };

  const isFavourited = !!favouriteUserFolderId;
  const FavouriteIcon = isFavourited ? FilledStarIcon : StarIcon;

  return (
    <button
      className='tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-bg-transparent tw-p-0 hover:tw-bg-blue-050 disabled:tw-pointer-events-none disabled:tw-opacity-30'
      disabled={
        createFavouriteUserFolderMutation.isLoading ||
        destroyFavouriteUserFolderMutation.isLoading
      }
      onClick={() => {
        (isFavourited ?
          handleRemoveFromFavouritesClick
        : handleAddToFavouritesClick)();
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <FavouriteIcon
        className={classNames(
          isHovered ? '[&_path]:tw-fill-blue-500'
          : isFavourited ?
            '[&_path]:tw-fill-blue-300 [&_path]:group-hover/row:tw-fill-blue-400'
          : '[&_path]:tw-fill-grey-500 [&_path]:group-hover/row:tw-fill-grey-700',
        )}
        height={20}
        width={20}
      />
      <span className='tw-sr-only'>
        {isFavourited ? 'Remove from' : 'Add to'} favourites
      </span>
    </button>
  );
}

FavouriteFolderToggleButton.propTypes = {
  favouriteUserFolderId: PropTypes.string,
  folderId: PropTypes.string.isRequired,
};
